// Ojito de los campos de contraseña (partials/_password_toggle): muestra u oculta lo escrito.
document.addEventListener('click', function (e) {
  const button = e.target.closest('.js-password-toggle')
  if (!button) return

  const input = button.parentElement.querySelector('input[type="password"], input[type="text"]')
  if (!input) return

  const show = input.type === 'password'
  input.type = show ? 'text' : 'password'
  button.querySelector('.js-password-show').classList.toggle('d-none', show)
  button.querySelector('.js-password-hide').classList.toggle('d-none', !show)
  const label = show ? 'Ocultar contraseña' : 'Mostrar contraseña'
  button.setAttribute('title', label)
  button.setAttribute('aria-label', label)
  button.setAttribute('aria-pressed', String(show))
  input.focus()
})
